export const RESET_PRODUCT = "RESET_PRODUCT"
export const CLEAR_PRODUCTS = "CLEAR_PRODUCTS";

export const QUERY_PENDING_PRODUCTS = "QUERY_PENDING_PRODUCTS"
export const QUERY_PRODUCTS = "QUERY_PRODUCTS"
export const QUERY_PRODUCTS_SUCCESS = "QUERY_PRODUCTS_SUCCESS"
export const QUERY_PRODUCTS_FAILED = "QUERY_PRODUCTS_FAILED"

export const GET_PRODUCTS = "GET_PRODUCTS"
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS"
export const GET_PRODUCTS_FAILED = "GET_PRODUCTS_FAILED"

export const GET_PRODUCT = "GET_PRODUCT"
export const GET_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS"
export const GET_PRODUCT_FAILED = "GET_PRODUCT_FAILED"

export const REGISTER_PRODUCT = "REGISTER_PRODUCT"
export const REGISTER_PRODUCT_SUCCESS = "REGISTER_PRODUCT_SUCCESS"
export const REGISTER_PRODUCT_FAILED = "REGISTER_PRODUCT_FAILED"

export const UPDATE_PRODUCT = "UPDATE_PRODUCT"
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS"
export const UPDATE_PRODUCT_FAILED = "UPDATE_PRODUCT_FAILED"

export const ORDER_PRODUCT = "ORDER_PRODUCT"
export const ORDER_PRODUCT_SUCCESS = "ORDER_PRODUCT_SUCCESS"
export const ORDER_PRODUCT_FAILED = "ORDER_PRODUCT_FAILED"
